import i18n from '@/i18n/i18n'

export const setTranslateTitle = (column) => {
  const value = column.translateValue ?? column.value
  const key = `label.${value}`
  return i18n.te(key) ? i18n.t(key) : column.text || column.value
}

export const filteredFields = (data, fields) => {
  return data.filter((a) => fields.indexOf(a.value) > -1)
}

export const deletedFields = (data, fields) => {
  return data.filter((a) => fields.indexOf(a.value) < 0)
}

export const DEFAULT_PARAMS = {
  page: 1,
  size: undefined,
  sort: 'id,desc',
}
export const DEFAULT_SIZE = 20
export const DEFAULT_CREATIVE_SIZE = 12

export const ROW_SIZES = [
  {
    text: 10,
    value: 10,
  },
  {
    text: 20,
    value: 20,
  },
  {
    text: 50,
    value: 50,
  },
  {
    text: 100,
    value: 100,
  },
  {
    text: 250,
    value: 250,
  },
  {
    text: 500,
    value: 500,
  },
]
